import { voidfallChapters } from './content';
export const voidfallCommonMistakes = voidfallChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('NAJCZĘSTSZE BŁĘDY'));
